export default __webpack_public_path__ + "static/media/GS1_logo.9f08002e.svg";